import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../Checkbox';

export default class extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    picked: PropTypes.bool.isRequired,
    required: PropTypes.bool.isRequired,
    onToggleSelect: PropTypes.func.isRequired,
    onToggleRequire: PropTypes.func.isRequired,
  }

  renderCheckbox(isChecked, onChange, id) {
    return (
      <Checkbox id={id} checked={isChecked} onChange={onChange} />
    );
  }

  render() {
    const question = this.props.question;
    const cellClass = this.props.picked ? '' : 'u-text-old-dark-grey';

    const pickedCheckbox = this.renderCheckbox(this.props.picked, this.props.onToggleSelect,
      `question-${question.field}-checkbox`);
    const requiredCheckbox = this.renderCheckbox(this.props.required, this.props.onToggleRequire,
      `question-${question.field}-require-checkbox`);

    return (
      <tr>
        <td className={cellClass}>{pickedCheckbox}</td>
        <td className={cellClass}><b>{question.fieldName}</b></td>
        <td className={cellClass}>{question.label}</td>
        <td className={cellClass}>{question.type}</td>
        <td className={cellClass}>{requiredCheckbox}</td>
      </tr>
    );
  }
}
